import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './PromoText.module.css';

export const PromoText = ({ color = 'baseColor', ...props }) => {
    const Tag = (() => {
        switch (props.tag) {
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'div':
            case 'span':
            case 'p':
            case 'label':
                return props.tag;
            case 'listItem':
                return 'li';
            case 'link':
                return 'a';
            default:
                return 'span';
        }
    })();

    const variantClass = (() => {
        switch (props.variant) {
            case 'h1':
                return styles.vH1;
            case 'h2':
                return styles.vH2;
            case 'h3':
                return styles.vH3;
            case 'h4':
                return styles.vH4;
            case 'subheader':
                return styles.vSubheader;
            case 'quote':
                return styles.vQuote;
            case 'label':
                return styles.vLabel;
            case 'note':
                return styles.vNote;
            case 'link':
                return styles.vLink;
            case 'div':
                return styles.vDiv;
            case 'span':
                return styles.vSpan;
            default:
                return styles.vSpan;
        }
    })();

    const safeClass = (prefix, value, styles) => {
        if (!value) return null;
        const key = `${prefix}${value.charAt(0).toUpperCase()}${value.slice(1)}`;
        return styles[key] || null;
    };

    const colorClassName = !props.gradientColor ? safeClass('color', props.color || color, styles) : null;

    const gradientClassName = props.gradientColor ? `bg${props.gradientColor.charAt(0).toUpperCase() + props.gradientColor.slice(1)}` : null;

    const className = clsx(
        styles.textBase,
        variantClass,
        colorClassName,
        gradientClassName,
        props.gradientColor && styles.gradientText,
        props.isBold && styles.isBold,
        props.nowrap && styles.nowrap,
        props.ellipsis && styles.ellipsis,
        props.textAlign === 'left' && styles.alignLeft,
        props.textAlign === 'center' && styles.alignCenter,
        props.textAlign === 'right' && styles.alignRight,
        props.cursorPointer && styles.cursorPointer,
        props.smallCaps && styles.smallCaps,
        props.tag === 'link' && styles.asLink,
    );

    return (
        <Tag
            className={className}
            dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
            onClick={props.onClick}
            onKeyPress={props.onKeyPress}
            href={props.href}
        >
            {props.children}
        </Tag>
    );
};

PromoText.propTypes = {
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'subheader', 'quote', 'div', 'span', 'link', 'label', 'note']),
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'div', 'span', 'link', 'label', 'p', 'listItem']),
    color: PropTypes.oneOf([
        'baseColor',
        'primary',
        'primaryB2B',
        'purple80',
        'purple40',
        'purple20',
        'gray80',
        'gray40',
        'gray20',
        'white',
        'whiteRgba48',
        'error',
        'success',
    ]),
    gradientColor: PropTypes.oneOf([
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'aubergine04',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    nowrap: PropTypes.bool,
    ellipsis: PropTypes.bool,
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    isBold: PropTypes.bool,
    href: PropTypes.string,
    cursorPointer: PropTypes.bool,
    smallCaps: PropTypes.bool,
};
